import React, { useEffect, useState } from "react";
import { ReservationCalendarWorkspaceModel, VenueWorkspaceModel } from "Services/API/API";
import LongShortLabel from "Components/LongShortLabel";

function getShortenString(str?: string) {
   return str?.match(/(?:\b(?!\d)\w(?=[a-z]*\b))|(?:\b\w+)/gi)
      ?.map(x => x.toUpperCase())
      .join("");
}

function getName(workspace: VenueWorkspaceModel, shorten?: boolean, duplicatedNames?: string[]) {
   const name = `${workspace.spaceTypeFormatted} for ${workspace.capacity}`;
   return duplicatedNames?.includes(name)
      ? name + ` - ${shorten ? getShortenString(workspace.name) : workspace.name}`
      : name;
}

export function useDuplicatedNames(workspaces: ReservationCalendarWorkspaceModel[]) {
   const [duplicatedNames, setDuplicatedNames] = useState<string[]>([]);
   useEffect(() => {
      const knownNames: string[] = [];
      const duplicatedNames: string[] = [];
      workspaces.forEach(w => {
         const name = getName(w.workspace);
         if (knownNames.includes(name)) {
            duplicatedNames.push(name);
         }
         else {
            knownNames.push(name);
         }
      });

      setDuplicatedNames(duplicatedNames);
   }, [workspaces]);
   return duplicatedNames;
}

interface WorkspaceSelectorItemProps {
   workspace: VenueWorkspaceModel;
   duplicatedNames: string[];
}

const WorkspaceSelectorItem: React.FC<WorkspaceSelectorItemProps> = ({ workspace, duplicatedNames }) => {
   return (<div className="rc-workspace-info">
      <LongShortLabel className="rc-workspace-name" title={workspace.name} long={getName(workspace, false, duplicatedNames)} short={getName(workspace, true, duplicatedNames)} />
      <div className="rc-workspace-price" title={workspace.pricesFormatted}>{workspace.pricesFormatted}</div>
   </div>)
}

export default WorkspaceSelectorItem;